import { DATA_REGION } from "../pages/trust-facts"

/** "2026-10-27" -> "2026年10月27日" (string maths, so no timezone shift). */
export const formatDateZh = (iso: string): string => {
  const [y, m, d] = iso.split("-").map(Number)
  return `${y}年${m}月${d}日`
}

const MONTHS_EN = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

/** "28 October 2026" or "28 Oct 2026" (the formats the English pages use) -> "2026年10月28日"; throws on anything else. */
export const englishDateToZh = (text: string): string => {
  const m = /^(\d{1,2}) ([A-Z][a-z]+) (\d{4})$/.exec(text)
  const month = m ? MONTHS_EN.findIndex((n) => n === m[2] || n.slice(0, 3) === m[2]) : -1
  if (!m || month < 0) throw new Error(`Unexpected English date "${text}"`)
  return `${m[3]}年${month + 1}月${Number(m[1])}日`
}

/** `DATA_COUNTRY` in Chinese. */
export const DATA_COUNTRY_ZH = "澳大利亚"

/** Data region named by the trust fact source (`DATA_REGION`), in Chinese; a new region needs a new entry. */
export const REGION_ZH: Record<string, string> = { Sydney: "悉尼" }

/** Chinese counterpart of `STORAGE_SENTENCE` (trust-facts.ts): database in Sydney, receipt files in Australia (Cloudflare location hint). */
export const STORAGE_SENTENCE_ZH = `账户数据存储在澳大利亚${REGION_ZH[DATA_REGION] ?? DATA_REGION}。收据文件存储在${DATA_COUNTRY_ZH}（Cloudflare 位置提示）。`
